import * as React from "react";
import { connect } from "react-redux";
import Modal from "../Modal";

import globalAction from '../../actions/global';

class WinModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    
    componentDidMount() {
        
    }
    __onLoginOk(_username) {
        const { onLoginOk } = this.props;
        onLoginOk && onLoginOk(_username);
    }
    __onClose() {
        const {onClose, toggleWinModal} = this.props;
        toggleWinModal(false);
        onClose && onClose();
    }
    __handleSubmitAddr(drawRecordId) {
        const { submitAddr, setPhoneDrawRecordId } = this.props;
        submitAddr && submitAddr();
        // 手机的中奖id
        setPhoneDrawRecordId(drawRecordId);
    }
    handleClick() {
        const {confirmClick} = this.props;
        confirmClick && confirmClick();
    }
    renderContent(prize) {
        const {prizeId, picture} = prize;
        let content = '';

        switch(prizeId) {
            case 1:
                content = <img src={picture} alt=""/>;
                break;
            case 2:
                content = <div className="m-myRecord-item__hdText"><span>8</span>元</div>;
                break;
            case 3:
                content = <div className="m-myRecord-item__hdText"><span>6</span>个月</div>;
                break;
            case 4:
                content = <div className="m-myRecord-item__hdText"><span>1</span>年</div>;
                break;
            case 5:
                content = <div className="w-mobile-pic"></div>;
                break;
            default:
                break;
        }
        return content;
    }
    renderName(data) {
        const {prizeId, name} = data;
        let content = '';
        switch(prizeId) {
            case 2:
            case 3:
            case 4:
                content = 'VIP邮箱服务期';
                break;
            case 1:
            case 5:
            default:
                content = name;
                break;
        }
        return content;
    }
    renderDesc(data) {
        let content = '';
        switch(data.prizeId) {
            case 1:
                content = <div>微信扫码，添加班主任,<br/>备注活动VIP帐号，即可入学</div>;
                break;
            case 2:
            case 3:
            case 4:
            case 5:
                content = <div>可在「我的礼品」查看</div>
                break;
            default:
                break;
        }
        return content;
    }
    render() {
        const {currPrizeId, prizes, isWinModalVisible} = this.props;
        let prize = {};
        prizes.forEach((item, index) => {
            if (item.prizeId === currPrizeId) {
                prize = item;
            }
        })

        return (
            <Modal isOpen={isWinModalVisible} title="恭喜您获得" className="w-win-modal" onClose={this.__onClose.bind(this)}>
                {
                    isWinModalVisible && <div>
                        <div className="m-winModal-content">
                            <div className="m-winModal-bd">
                                {this.renderContent(prize)}
                            </div>
                            <div className="m-winModal-name">{this.renderName(prize)}</div>
                        </div>
                        <div className="m-winModal-ft">
                            {this.renderDesc(prize)}
                        </div>
                    </div>
                }
            </Modal>
        );
    }
}

function mapStateToProps(state) {
    return {
        currPrizeId: state.global.currPrizeId,
        prizes: state.global.prizes || [],
        isWinModalVisible: state.global.isWinModalVisible,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setPhoneDrawRecordId(id) {
            dispatch(globalAction.setPhoneDrawRecordId(id));
        },
        toggleWinModal(flag) {
            dispatch(globalAction.toggleWinModal(flag));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WinModal);
